import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { FaUserEdit, FaEye, FaEyeSlash } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

const API = process.env.REACT_APP_API_BASE_URL;

export default function AkunAffiliate() {
  const token = Cookies.get("token");
  const [showPassword, setShowPassword] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  const [showEdit, setShowEdit] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  /*
  ============================
  GET PROFILE
  ============================
  */

  const fetchProfile = async () => {
    try {
      const res = await axios.get(`${API}/api/affiliate/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setUser(res.data);

      setForm({
        name: res.data.name,
        email: res.data.email,
        phone: res.data.phone,
        password: "",
      });
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  /*
  ============================
  HANDLE INPUT
  ============================
  */

  const handleChange = (e: any) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  /*
  ============================
  UPDATE PROFILE
  ============================
  */

  const handleUpdate = async () => {
    const confirm = await Swal.fire({
      title: "Update Profil?",
      text: "Yakin ingin menyimpan perubahan?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya Simpan",
    });

    if (!confirm.isConfirmed) return;

    try {
      const res = await axios.put(`${API}/api/affiliate/me`, form, {
        headers: { Authorization: `Bearer ${token}` },
      });

      Swal.fire("Berhasil", res.data.message, "success");

      setShowEdit(false);
      fetchProfile();
    } catch (err: any) {
      Swal.fire("Error", err.response?.data?.message || "Gagal update profil", "error");
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  if (loading) {
    return <div className="p-10 text-center">Loading...</div>;
  }

  return (
    <div className=" max-w-5xl mx-auto ">
      {/* CARD PROFILE */}
      <div className="bg-white shadow-lg rounded-2xl border overflow-hidden">
        {/* HEADER */}
        <div className="bg-primary text-white p-6 flex flex-col sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h2 className="text-xl font-semibold">Akun Affiliate</h2>
            <p className="text-sm opacity-90">Kelola informasi akun anda</p>
          </div>

          <button onClick={() => setShowEdit(true)} className="mt-4 sm:mt-0 flex items-center gap-2 bg-white text-primary px-4 py-2 rounded-lg hover:opacity-90">
            <FaUserEdit />
            Edit Profil
          </button>
        </div>

        {/* BODY */}
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <p className="text-sm text-gray-500">Nama</p>
            <p className="font-semibold">{user.name}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Email</p>
            <p className="font-semibold">{user.email}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Nomor Telepon</p>
            <p className="font-semibold">{user.phone}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Affiliate Code</p>
            <p className="font-semibold text-primary">{user.affiliate_code}</p>
          </div>

          <div>
            <p className="text-sm text-gray-500">Status</p>
            <span className="bg-green-100 text-green-600 px-3 py-1 rounded text-xs">{user.status}</span>
          </div>

          <div>
            <p className="text-sm text-gray-500">Tanggal Daftar</p>
            <p className="font-semibold">{new Date(user.created_at).toLocaleDateString("id-ID")}</p>
          </div>
        </div>
      </div>

      {/* MODAL EDIT */}
      {showEdit && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
          <div className="bg-white rounded-2xl w-[420px] max-w-[95%] relative shadow-xl">
            {/* CLOSE */}
            <div className="absolute right-4 top-4 cursor-pointer" onClick={() => setShowEdit(false)}>
              <IoClose size={22} />
            </div>

            <div className="p-6 space-y-4">
              <h3 className="text-lg font-semibold">Edit Profil</h3>

              {/* NAME */}
              <div>
                <label className="text-sm">Nama</label>
                <input type="text" name="name" value={form.name} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
              </div>

              {/* EMAIL */}
              <div>
                <label className="text-sm">Email</label>
                <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
              </div>

              {/* PHONE */}
              <div>
                <label className="text-sm">Nomor Telepon</label>
                <input type="text" name="phone" value={form.phone} onChange={handleChange} className="w-full border rounded-lg p-2 mt-1" />
              </div>

              {/* PASSWORD */}
              <div>
                <label className="text-sm">
                  Password Baru <span className="text-gray-400">(opsional)</span>
                </label>

                <div className="relative mt-1">
                  <input type={showPassword ? "text" : "password"} name="password" value={form.password} onChange={handleChange} className="w-full border rounded-lg p-2 pr-10" placeholder="Masukkan password baru" />

                  <div onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500">
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>
              </div>

              {/* BUTTON */}
              <button onClick={handleUpdate} className="w-full bg-primary text-white py-2 rounded-lg hover:opacity-90 mt-3">
                Simpan Perubahan
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
